import { ComponentPropsWithoutRef } from 'react'
import styled from 'styled-components'

const SiteContainer: React.FC<ComponentPropsWithoutRef<'div'>> = ({
  children,
  ...props
}) => <Container {...props}>{children}</Container>

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export default SiteContainer
